import { createSlice } from "@reduxjs/toolkit"
import type { RootState } from "./store"
import type { PayloadAction } from "@reduxjs/toolkit"

type AppPanelState = {
    // CBD-2211 will switch this to be data for React to build the component, rather than React taking a div from TS in props
    // For now we just need to track when any state update happens on the TS side
    appPanelVersion: number
}

const initialState: AppPanelState = {
    appPanelVersion: 0,
}

export const appPanelSlice = createSlice({
    name: "appPanel",
    initialState: initialState,
    reducers: {
        // TODO CBD-2211 use payload for app panel data
        appPanelUpdate: (state, { payload }: PayloadAction<void>) => {
            state.appPanelVersion += 1
        },
    },
})

export const { appPanelUpdate } = appPanelSlice.actions

export const selectAppPanelVersion = (state: RootState): number =>
    state.appPanel.appPanelVersion

export default appPanelSlice.reducer
